import React, { useState } from "react";
import { CopyClipboardButton } from "./CopyCliboard.button";

interface TextViewComponentProps {
  text: string;
  maxLength?: number;
  showMoreButton?: boolean;
  showCopyButton?: boolean;
}

const linkify = (text: string) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const parts = text.split(urlRegex);

  return parts.map((part, index) => {
    if (part.match(urlRegex)) {
      return (
        <a href={part} key={index} target="_blank" rel="noopener noreferrer">
          {part}
        </a>
      );
    }
    return <React.Fragment key={index}>{part}</React.Fragment>;
  });
};

export function TextViewComponent({
  text,
  maxLength = 200,
  showMoreButton = false,
  showCopyButton = false,
}: TextViewComponentProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const isLongText = showMoreButton && text.length > maxLength;

  const displayText =
    isLongText && !isExpanded ? `${text.substring(0, maxLength)}...` : text;

  return (
    <div style={{ position: "relative" }}>
      <div style={{ whiteSpace: "pre-wrap" }}>{linkify(displayText)}</div>
      {isLongText && (
        <button className="btn btn-link btn-sm" onClick={toggleExpand}>
          {isExpanded ? "Show Less" : "Show More"}
        </button>
      )}
      {showCopyButton && (
        <div style={{ position: "absolute", top: 0, right: 0 }}>
          <CopyClipboardButton textToCopy={text} />
        </div>
      )}
    </div>
  );
}
